const getRulesetDetailResponse = (response) => {
  return response?.scheduleRuleset;
};

export default getRulesetDetailResponse;
